export default __webpack_public_path__ + "static/media/img_gas_phase_en_04.dbd79c9f.png";